import React, { useEffect, useState } from 'react'
import { SearchFilterResponse } from '../../SearchFilter/Types/SerachFileter';
import { getAllSearchFiltersBySubscriptionPlan } from '../../SearchFilter/Services/SearchFilterService';

function SearchFiltersBasedOnSubscriptionPlanPage() {


 const [adminData, setAdminData] = useState<SearchFilterResponse []>([]);
      const [loading, setLoading] = useState<boolean>(true);
      const [error, setError] = useState<string>("");
      
      useEffect(() => {
        const fetchCandidate = async () => {
          try {
            setLoading(true); // Ensure loading is true when starting
            const response = await getAllSearchFiltersBySubscriptionPlan(localStorage.getItem("userId") || "");
  
            console.log("Search Filters based on Plan Response:", response);
      
            if (response.success) {
              setAdminData(response.data);
            } else {
              setError(response.message || "Could not retrieve recruiter profile.");
            }
          } catch (err) {
            setError("An unexpected error occurred while loading the profile.");
            console.error(err);
          } finally {
            setLoading(false);
          }
        };
      
        fetchCandidate();
      }, []); // Empty dependency array is fine if using localStorage



  return (
    <div>SearchFiltersBasedOnSubscriptionPlanPage</div>
  )
}

export default SearchFiltersBasedOnSubscriptionPlanPage